import styled, { css } from 'styled-components';
import { colors } from '../../style';
import BaseCard, { BaseCardProps } from './base-card';

type RowCardVariant = 'default' | 'white' | 'bordered';
type AccentVariant = 'positive';

type RowCardProps = BaseCardProps & {
  variant?: RowCardVariant;
  accent?: AccentVariant;
};

const accentColors = {
  positive: colors.positive,
};

export const variants: Record<RowCardVariant, ReturnType<typeof css>> = {
  default: css`
    background: ${colors.white};
    border-bottom: 1px solid ${colors.gray300};
  `,
  white: css`
    ${colors.white}
  `,
  bordered: css`
    border: 1px solid ${colors.gray300};
  `,
};

const RowCard = styled(BaseCard).withConfig({
  shouldForwardProp: prop => !['variant'].includes(prop),
})<RowCardProps>`
  transition:
    background-color 250ms ease-out,
    border-radius 250ms ease-out !important;
  height: 100%;
  outline: none;
  ${({ variant }) => variants[variant ?? 'default']};
  ${props =>
    props.accent &&
    css`
      border: 1px solid ${accentColors[props.accent]};
    `}
  background: white;
  display: block;
  width: 100%;
  flex-grow: 1;

  &:not(.disabled):not(disabled) {
    cursor: pointer;
  }

  &:hover,
  &:focus-visible,
  &:active,
  &.active {
    outline: 1px solid ${colors.white};
    background: ${props => props.theme.actionLight};
    ${props =>
      props.accent &&
      css`
        border: 1px solid ${accentColors[props.accent]};
      `}
  }


  }
`;

export default RowCard;
